<script>
import { onMount } from "svelte"
import Icon from "@local/components/images/Icon.svelte"

let showBackToTop = false

onMount(() => {
  window.addEventListener("scroll", handleScroll)
  return () => window.removeEventListener("scroll", handleScroll)
})

function handleScroll() {
  showBackToTop = window.scrollY > 300
}

function scrollToTop() {
  window.scrollTo({ top: 0, behavior: "smooth" })
}
</script>

{#if showBackToTop}
  <button
    on:click="{scrollToTop}"
    class="fixed bottom-6 right-4 bg-gray-800 text-white p-3 rounded-full shadow-lg hover:bg-gray-700 transition-colors duration-200"
    title="Voltar ao topo"
  >
    <Icon size="xl">arrow_upward</Icon>
  </button>
{/if}
